export function emitRunEvents(run, onEvent) {
  if (typeof onEvent !== 'function') return
  if (run?.runId) emitRunStatus(run, onEvent)
  if (Array.isArray(run?.progressEvents)) run.progressEvents.forEach((event) => onEvent(event))
}

function emitRunStatus(run, onEvent) {
  const status = run.status || 'running'
  onEvent({
    type: 'run_status',
    runId: run.runId,
    status,
    statusUrl: run.statusUrl || `/api/hermes/runs/${run.runId}`,
    traceText: `Hermes workflow ${status}.`,
  })
}
